import axiosInstance, { API_BASE_URL } from '../config/axios.config';
import ENDPOINTS from '../config/endpoints';
import tokenManager from '../utils/tokenManager';

class LabService {
  // Use the shared base URL constant
  baseUrl = API_BASE_URL;
  async list({ page = 0, limit = 10, search = '' } = {}) {
    try {
      const res = await axiosInstance.get(ENDPOINTS.LABS.LIST, {
        params: { page, limit, search },
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async userList({ page = 0, limit = 10, search = '' } = {}) {
    try {
      const res = await axiosInstance.get(ENDPOINTS.LABS.USER_LIST, {
        params: { page, limit, search },
      });
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async create(payload) {
    try {
      const res = await axiosInstance.post(ENDPOINTS.LABS.CREATE, payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async update(uuid, payload) {
    try {
      const res = await axiosInstance.put(ENDPOINTS.LABS.UPDATE(uuid), payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async statusUpdate(uuid, is_active) {
    try {
      const res = await axiosInstance.put(ENDPOINTS.LABS.STATUS_UPDATE(uuid), { is_active });
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async view(uuid) {
    try {
      const res = await axiosInstance.get(ENDPOINTS.LABS.VIEW(uuid));
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  // Download PDF with authentication
  async downloadPdf(uuid) {
    const url = `${this.baseUrl}${ENDPOINTS.LABS.DOWNLOAD(uuid)}`;
    const token = tokenManager.getAccessToken();

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      mode: 'cors',
      credentials: 'omit',
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch download URL: ${response.status}`);
    }

    const data = await response.json();

    if (!(data.status || data.success) || !data?.file_url) {
      throw new Error('Download URL not found in API response');
    }

    return data.file_url;
  }

  // View PDF with authentication
  async viewPdf(uuid) {
    const url = `${this.baseUrl}${ENDPOINTS.LABS.VIEW(uuid)}`;
    const token = tokenManager.getAccessToken();

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        mode: 'cors',
        credentials: 'omit',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Case 1: Backend returns direct file_url
      if ((data.status || data.success) && data.file_url) {
        return data.file_url;
      }

      // Case 2: Backend returns nested data object with document filename
      if ((data.status || data.success) && data.data && data.data.document) {
        const uploadsBaseUrl = this.baseUrl.replace('/api/v1', '');
        const fileName = data.data.document;
        return `${uploadsBaseUrl}uploads/${fileName}`;
      }

      return url;
    } catch (error) {
      console.error('Error fetching view URL:', error);
      return url;
    }
  }
}

const labService = new LabService();
export default labService;